import http from './http'

export default {
  getMembers: draftId => http.get(`/v2/drafts/${draftId}/event-members`),
  getPaymentStatus: (draftId, primaryUserId) => http.get(`/v2/drafts/${draftId}/event-members/${primaryUserId}/payment-status`),
  updatePaymentStatus: (draftId, primaryUserId, data) => http.patch(`/v2/drafts/${draftId}/event-members/${primaryUserId}/payment-status`, data, { silent: true }),
  updateMemberStatus: (draftId, eventMemberId) => http.patch(`/v2/drafts/${draftId}/event-members/${eventMemberId}/status`, {}, { silent: true }),
  unscratchMemberStatus: (draftId, eventMemberId) => http.post(`/v2/drafts/${draftId}/event-members/${eventMemberId}/unscratch`, {}, { silent: true })
}



// WEBPACK FOOTER //
// ./src/services/api/draftEventMembers.js